(function ($) {
    "use strict";

    $.doneAddInterstionObserverToDoLazyload = function doneAddInterstionObserverToDoLazyload(item, cb) {
        var config = {
            // give a 50px margin
            rootMargin: '50px 0px',
            threshold: 0.01
        };
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                // Are we in viewport?
                if (entry.intersectionRatio <= 0) {
                    return;
                }

                // Stop watching and do the callback
                observer.unobserve(entry.target);
                cb(entry.target);
            });
        }, config);
        observer.observe(item);
    }

    $.doneHookInfiniteScrollIndicators = function doneHookInfiniteScrollIndicators() {
        if ($(".done__filter_results_infinitescroll").length > 0) {
            $(".done__filter_results_infinitescroll").each(function (i, item) {
                if ($(item).hasClass('added_observer')) {
                    return;
                }
                $(item).addClass('added_observer')
                $.doneAddInterstionObserverToDoLazyload(item, function () {
                    $(item).addClass('loading');
                    $.get($(item).data('next'), function (data) {
                        $(item).replaceWith(data);

                        // just a little delay
                        setTimeout($.doneHookInfiniteScrollIndicators, 100);
                    });
                });
            });
        }
    }

    $(function () {
        var filterForms = $(".done_awesome_filter_form");
        if (filterForms.length === 0) {
            return;
        }
        $.doneHookInfiniteScrollIndicators();
    });

})(jQuery);